"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var ScrollElement = /** @class */ (function (_super) {
    __extends(ScrollElement, _super);
    function ScrollElement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollElementInstance = null;
        _this.scrollLeft = 0;
        _this.scrollEventInit = false;
        return _this;
    }
    ScrollElement.prototype.mounted = function () {
        this.initScrollEvent();
    };
    Object.defineProperty(ScrollElement.prototype, "scrollElement", {
        get: function () {
            if (!this.scrollElementInstance) {
                this.scrollElementInstance = this.context.querySelector(this.targetSelector);
            }
            return this.scrollElementInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollElement.prototype, "isScrollStart", {
        get: function () {
            if (!this.scrollElement) {
                return true;
            }
            if (this.scrollElement.clientWidth === 0) {
                return true;
            }
            return this.scrollLeft <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollElement.prototype, "isScrollEnd", {
        get: function () {
            if (!this.scrollElement) {
                return true;
            }
            if (this.scrollElement.clientWidth === 0) {
                return true;
            }
            return this.scrollElement.offsetWidth + this.scrollLeft >= this.scrollElement.scrollWidth;
        },
        enumerable: false,
        configurable: true
    });
    ScrollElement.prototype.initScrollEvent = function (maxInitTries) {
        var _this = this;
        if (maxInitTries === void 0) { maxInitTries = 10; }
        var i = 0;
        var initEvent = function () {
            if (_this.scrollEventInit) {
                clearInterval(intervalId);
                return;
            }
            if (i >= maxInitTries) {
                clearInterval(intervalId);
                throw new Error("Element with selector \"".concat(_this.targetSelector, " not found, after ").concat(i, " tries\""));
            }
            i++;
            try {
                // query element
                _this.scrollElement;
            }
            catch (err) {
                return;
            }
            if (!_this.scrollElement) {
                return;
            }
            if (!_this.scrollEventInit) {
                _this.scrollEventInit = true;
                var scrolling_1 = false;
                _this.scrollElement.addEventListener('scroll', function () {
                    if (!scrolling_1) {
                        scrolling_1 = true;
                    }
                });
                setInterval(function () {
                    if (scrolling_1) {
                        scrolling_1 = false;
                        if (_this.scrollElement) {
                            _this.scrollLeft = _this.scrollElement.scrollLeft;
                        }
                    }
                }, 300);
            }
        };
        initEvent();
        var intervalId = setInterval(initEvent, 500);
    };
    ScrollElement.prototype.scrollBackward = function () {
        if (!this.scrollElement) {
            return;
        }
        var distance = this.scrollElement.clientWidth > 0
            ? (this.scrollElement.clientWidth * this.scrollDistancePercentage) / 100
            : 0;
        var scrollLeft = this.scrollElement.scrollLeft - distance;
        this.scrollElement.scroll({
            left: scrollLeft,
        });
    };
    ScrollElement.prototype.scrollForward = function () {
        if (!this.scrollElement) {
            return;
        }
        var distance = this.scrollElement.clientWidth > 0
            ? (this.scrollElement.clientWidth * this.scrollDistancePercentage) / 100
            : 0;
        var scrollLeft = this.scrollElement.scrollLeft + distance;
        this.scrollElement.scroll({
            left: scrollLeft,
        });
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], ScrollElement.prototype, "context", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], ScrollElement.prototype, "targetSelector", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: 40 })
    ], ScrollElement.prototype, "scrollDistancePercentage", void 0);
    ScrollElement = __decorate([
        vue_class_component_1.default
    ], ScrollElement);
    return ScrollElement;
}(vue_1.default));
exports.default = ScrollElement;
